import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import { INITIAL_EMAILS_TO_GENERATE, appStore } from '../../services/appStore';

import { insightsApi } from './api';
import { insightsQueryKey } from './insightsQueryKey';

export const useEmailsQuotaQuery = () => {
  const { isOpen } = useAppState();
  return useQuery({
    queryKey: insightsQueryKey.emailsQuota(),
    queryFn: async () => {
      const quota = await insightsApi.fetchEmailsQuota();
      appStore.setEmailsToGenerateCount(Math.min(quota.remaining, INITIAL_EMAILS_TO_GENERATE));
      return quota;
    },
    enabled: isOpen,
  });
};
